import type { RideBatchEnd } from './batch_wire.js';

/**
 * Como as variáveis do template `mobility99_ride_link` viram texto. UMA fonte para o envio
 * (`mobility-batch`) e para a prévia do gestor (web-chat): as duas dizem o mesmo por construção.
 */

const FREE_END = 'você escolhe';
const UNNAMED_PLACE = 'local definido pelo organizador';
const SAO_PAULO = new Intl.DateTimeFormat('pt-BR', {
  timeZone: 'America/Sao_Paulo',
  day: '2-digit',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
});

export function rideLinkFirstName(name: string): string {
  return name.trim().split(/\s+/)[0] ?? name;
}

/** A ponta como a mensagem a diz: "você escolhe", o nome do lugar, senão o endereço. */
export function rideLinkEndLabel(end: RideBatchEnd): string {
  if (end.kind === 'free') return FREE_END;
  return end.place.label ?? end.place.address ?? UNNAMED_PLACE;
}

/** "05 nov 2026, 07:30", no fuso de São Paulo (o mês abreviado vem com ponto: "nov."). */
function stamp(at: Date | string): string {
  const parts = SAO_PAULO.formatToParts(new Date(at));
  const part = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((p) => p.type === type)?.value ?? '';
  const month = part('month').replace('.', '');
  return `${part('day')} ${month} ${part('year')}, ${part('hour')}:${part('minute')}`;
}

/** "05 nov 2026, 07:00 até 07 nov 2026, 23:00". */
export function rideLinkValidity(window: {
  startsAt: Date | string;
  endsAt: Date | string;
}): string {
  return `${stamp(window.startsAt)} até ${stamp(window.endsAt)}`;
}
